// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

/* 路由 */
import router from './router'

/* axios */
import api from './api/api'
Vue.prototype.$api = api;

/* 过滤 */
import filter from './util/filter'
Object.keys(filter).forEach(key=>Vue.filter(key,filter[key]))

/* swiper */
import '../node_modules/swiper/swiper-bundle.css';   //swiper6.0样式路径
import Swiper, { Navigation, Autoplay,Thumbs, Pagination} from 'swiper'; //相关组件
Swiper.use([ Navigation, Autoplay,Thumbs, Pagination]);
// vuex
import store from './store';
/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'

 
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name,Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name,Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name,GoTop)
Vue.config.productionTip = false

// video
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)

// ElementUI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);



router.beforeEach((to, from, next) => {
    if(to.meta.title){
      document.title = to.meta.title
    }
    next();
});



router.afterEach((to,from,next) => {
  document.body.scrollTop =0;
  document.documentElement.scrollTop = 0;
  });
  
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

// 时间戳 yyyy-mm-dd 时间格式：20200820175002
Vue.filter('formatDBDateToDate', (time = '') => {
  if (!time) {
    return (time = '/');
  }
  if (time.includes('-')) {
    return time;
  }
  const Year = time.slice(0, 4);
  const Month = time.slice(4, 6);
  const Day = time.slice(6, 8);
  return (time = `${Year}-${Month}-${Day}`);
});




// WEBPACK FOOTER //
// ./src/main.js